import { defineStore } from 'pinia'

export const useSessionStore = defineStore('session', {
  state: () => ({
    data: {}
  }),
  
  getters: {
    get: (state) => (key) => {
      // Check localStorage first, then sessionStorage, then in-memory store
      const localValue = localStorage.getItem(key)
      if (localValue !== null) {
        try {
          return JSON.parse(localValue)
        } catch {
          return localValue
        }
      }
      
      const sessionValue = sessionStorage.getItem(key)
      if (sessionValue !== null) {
        try {
          return JSON.parse(sessionValue)
        } catch {
          return sessionValue
        }
      }
      
      return state.data[key]
    }
  },
  
  actions: {
    set(key, value, persist = true) {
      this.data[key] = value
      
      if (persist) {
        try {
          localStorage.setItem(key, JSON.stringify(value))
        } catch {
          localStorage.setItem(key, value)
        }
      } else {
        try {
          sessionStorage.setItem(key, JSON.stringify(value))
        } catch {
          sessionStorage.setItem(key, value)
        }
      }
    },
    
    remove(key) {
      delete this.data[key]
      localStorage.removeItem(key)
      sessionStorage.removeItem(key)
    },
    
    clear() {
      this.data = {}
      localStorage.clear()
      sessionStorage.clear()
    },
    
    exists(key) {
      return localStorage.getItem(key) !== null || 
             sessionStorage.getItem(key) !== null || 
             key in this.data
    }
  }
})
